import React from 'react';
import WebsiteLayout from './WebsiteLayout';
import ProductsBanner from './components/productsbanner';
import Products1 from './components/products1';
import Products2 from './components/products2';
import Products3 from './components/products3';


const RoboticsProduct = () => {

    return(
        <WebsiteLayout>
        <ProductsBanner/>
        <Products1/>
        <Products2/>
        <Products3/>



        </WebsiteLayout>
        
    );



}

export default RoboticsProduct;



